import React, { useState } from "react";
import { awardsData } from "../../constant/constant";
const Award = () => {
  const [expanded, setExpanded] = useState(false);
  const awards = expanded ? awardsData : awardsData.slice(0, 3);
  const toggleExpanded = () => {
    const isCollapsing = expanded;
    setExpanded(!expanded);
    if (isCollapsing)
      window.requestAnimationFrame(() =>
        document.getElementById("awards")?.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "start",
        }),
      );
  };
  return (
    <section id="awards" className="section">
      <p className="eyebrow">Recognition</p>
      <h2 className="section-title">Awards & achievements</h2>
      <div className="recognition-grid">
        {awards.map((award) => (
          <article className="panel recognition-card" key={award.title}>
            <span>{award.year}</span>
            <h3>{award.title}</h3>
            <b>{award.sub}</b>
            <p>{award.description}</p>
          </article>
        ))}
      </div>
      <button
        className="button-secondary journey-button"
        onClick={toggleExpanded}
      >
        {expanded ? "Show less" : "View all achievements"}
      </button>
    </section>
  );
};
export default Award;
